// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.process-balance .upload-area {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
  margin-bottom: 20px;
}
.process-balance .upload-area:hover {
  border-color: #198754;
  background-color: #d1e7dd;
}
.process-balance .upload-area.drag-over {
  border-color: #198754;
  background-color: #d1e7dd;
}
.process-balance .upload-area .upload-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 10px;
}
.process-balance .upload-area p {
  margin: 10px 0 5px;
  font-weight: 500;
  color: #495057;
}
.process-balance .upload-area small {
  color: #6c757d;
}
.process-balance .options-panel .alert {
  word-break: break-all;
  font-family: monospace;
  font-size: 12px;
}
.process-balance .options-panel .form-label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.process-balance .options-panel .form-control {
  border-radius: 4px;
}
.process-balance .options-panel .form-text {
  margin-top: 4px;
}
.process-balance .actions button {
  position: relative;
}
.process-balance .actions button .spinner-border {
  width: 1rem;
  height: 1rem;
  margin-left: 8px;
}
.process-balance .actions button:disabled {
  cursor: not-allowed;
}
.process-balance #messagesContainer {
  margin-bottom: 20px;
}
.process-balance #editorCard .card-body {
  padding: 0;
  position: relative;
}
.process-balance #placeholderCard .card-body {
  padding: 60px 20px;
}
/*# sourceMappingURL=process-balance.css.map */`, "",{"version":3,"sources":["webpack://./process-balance.less","webpack://./ClientApp/components/process-balance.less"],"names":[],"mappings":"AAAA;EAEQ,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;ACAR;ADEQ;EACI,qBAAA;EACA,yBAAA;ACAZ;ADGQ;EACI,qBAAA;EACA,yBAAA;ACDZ;ADjBA;EAsBY,eAAA;EACA,cAAA;EACA,mBAAA;ACFZ;ADtBA;EA4BY,kBAAA;EACA,gBAAA;EACA,cAAA;ACHZ;AD3BA;EAkCY,cAAA;ACJZ;AD9BA;EAwCY,qBAAA;EACA,sBAAA;EACA,eAAA;ACPZ;ADnCA;EA8CY,gBAAA;EACA,qBAAA;ACRZ;ADvCA;EAmDY,kBAAA;ACTZ;AD1CA;EAuDY,eAAA;ACVZ;AD7CA;EA6DY,kBAAA;ACbZ;ADhDA;EAgEgB,WAAA;EACA,YAAA;EACA,gBAAA;ACbhB;ADgBY;EACI,mBAAA;ACdhB;ADxDA;EA4EQ,mBAAA;ACjBR;AD3DA;EAiFY,UAAA;EACA,kBAAA;ACnBZ;AD/DA;EAwFY,kBAAA;ACtBZ;AACA,8CAA8C","sourcesContent":[".process-balance {\n    .upload-area {\n        border: 2px dashed #dee2e6;\n        border-radius: 8px;\n        padding: 40px 20px;\n        text-align: center;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        background-color: #f8f9fa;\n        margin-bottom: 20px;\n\n        &:hover {\n            border-color: #198754;\n            background-color: #d1e7dd;\n        }\n\n        &.drag-over {\n            border-color: #198754;\n            background-color: #d1e7dd;\n        }\n\n        .upload-icon {\n            font-size: 48px;\n            display: block;\n            margin-bottom: 10px;\n        }\n\n        p {\n            margin: 10px 0 5px;\n            font-weight: 500;\n            color: #495057;\n        }\n\n        small {\n            color: #6c757d;\n        }\n    }\n\n    .options-panel {\n        .alert {\n            word-break: break-all;\n            font-family: monospace;\n            font-size: 12px;\n        }\n\n        .form-label {\n            font-weight: 600;\n            margin-bottom: 0.5rem;\n        }\n\n        .form-control {\n            border-radius: 4px;\n        }\n\n        .form-text {\n            margin-top: 4px;\n        }\n    }\n\n    .actions {\n        button {\n            position: relative;\n\n            .spinner-border {\n                width: 1rem;\n                height: 1rem;\n                margin-left: 8px;\n            }\n\n            &:disabled {\n                cursor: not-allowed;\n            }\n        }\n    }\n\n    #messagesContainer {\n        margin-bottom: 20px;\n    }\n\n    #editorCard {\n        .card-body {\n            padding: 0;\n            position: relative;\n        }\n    }\n\n    #placeholderCard {\n        .card-body {\n            padding: 60px 20px;\n        }\n    }\n}\n",".process-balance .upload-area {\n  border: 2px dashed #dee2e6;\n  border-radius: 8px;\n  padding: 40px 20px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: #f8f9fa;\n  margin-bottom: 20px;\n}\n.process-balance .upload-area:hover {\n  border-color: #198754;\n  background-color: #d1e7dd;\n}\n.process-balance .upload-area.drag-over {\n  border-color: #198754;\n  background-color: #d1e7dd;\n}\n.process-balance .upload-area .upload-icon {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 10px;\n}\n.process-balance .upload-area p {\n  margin: 10px 0 5px;\n  font-weight: 500;\n  color: #495057;\n}\n.process-balance .upload-area small {\n  color: #6c757d;\n}\n.process-balance .options-panel .alert {\n  word-break: break-all;\n  font-family: monospace;\n  font-size: 12px;\n}\n.process-balance .options-panel .form-label {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n.process-balance .options-panel .form-control {\n  border-radius: 4px;\n}\n.process-balance .options-panel .form-text {\n  margin-top: 4px;\n}\n.process-balance .actions button {\n  position: relative;\n}\n.process-balance .actions button .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  margin-left: 8px;\n}\n.process-balance .actions button:disabled {\n  cursor: not-allowed;\n}\n.process-balance #messagesContainer {\n  margin-bottom: 20px;\n}\n.process-balance #editorCard .card-body {\n  padding: 0;\n  position: relative;\n}\n.process-balance #placeholderCard .card-body {\n  padding: 60px 20px;\n}\n/*# sourceMappingURL=process-balance.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
